import { createContext } from '@woorcs/utils'

import { UseCalendarStateReturn } from './useCalendarState'

type CalendarContext = UseCalendarStateReturn

export const [CalendarContextProvider, useCalendarContext] =
  createContext<CalendarContext>()
